import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'fr', 'de', 'tr'],

    // Ne pas retomber sur le parent 'en' si 'en-US' est détecté
    // (i18next utilisera automatiquement 'en' comme langue "proche")
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,

    // Perf maximale : pas de fallback additionnel au boot
    // (si tu préfères un fallback, mets `fallbackLng: 'fr'` => +1 requête de fallback)
    fallbackLng: 'fr',

    // Chemin qui correspond à public/locales/<lng>/<ns>.json
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // Deux namespaces existent dans ton projet : translation.json et menu.json
    ns: ['translation'],
    defaultNS: 'translation',

    detection: {
      order: ['navigator', 'htmlTag', 'localStorage', 'cookie', 'path', 'subdomain'],
      caches: ['localStorage'],
    },

    debug: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
